import mutations from './drugBnoArchive.mutations'
import actions from './drugBnoArchive.actions'
import getters from './drugBnoArchive.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
